// https://vuex.vuejs.org/en/state.html

export default {
  objects: [],
  object: {
    details : {
      name : ''
    }
  },
  temp_address: {},
  contracts: [],
  contract: {},
  templates: [],
  alltemplates: [],
  details: {},
  types: [],
  type: {},
  forms: [],
  form: {
    create: false,
    reference: "",
    content: "",

    show: false,
    name: "",
    description: "",

    template: {},
    templates: []
  },
  log: [],
  pdfStore: {
    show: false,
    file: "",
    available: false,
    download: null
  },

  createObject: {
    show: false,
    code: ""
  },
  archive: {
    show: false,
    type: "",
    description: "",
    reference: null
  },

  settings: {
    managed_list : [], 
    crm_list : [],
    template: null,
    templates: [],
    objects: [],
    objectFields: [],
    newTemplate: {
      template: {
        name: "",
        code: ""
      },
      show: false,
      nameRules: [v => !!v || "Verplicht veld"],
      valid: false
    },
    newObject: {
      type: {
        name: "",
        parent: null
      },
      show: false,
      nameRules: [v => !!v || "Verplicht veld"],
      valid: false
    },
    deleteObject: false
  },
  exportList : []
};
